import axios from 'axios';
import { Regions } from 'utils/constants';

export const setupGlobalAxiosDefaults = (region: Regions) => {
  axios.defaults.withCredentials = true;
  axios.defaults.baseURL = process.env[`REACT_APP_SG1_API_PREFIX_${region}`];
};
